/* cjl-familias — ensamblado de H2 por palabra + escenas de familia (20 sep):
   entrada reveal al asentarse cada tarjeta (opción C) y salida S3 — el contenido
   de la tarjeta cubierta se desvanece y se hunde según cuánto la tapa la siguiente
   (el nombre queda fuera del wrapper __body: la franja del deck se lee siempre).
   El viaje de color de página se retiró (19 sep): el color vive solo en los campos.
   Vanilla, sin GSAP (docs/18 F4.3). Init por instancia; limpieza en section:unload.
   prefers-reduced-motion o checkbox de animación off → no se registra nada. */
(function () {
  'use strict';
  var instances = {};

  function init(root) {
    var id = root.dataset.sectionId;
    if (!id || instances[id]) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animate = root.dataset.animate === 'true' && !reduced;
    var observers = [];

    /* Ensamblado del nombre de familia, por palabra, una vez. */
    var headings = root.querySelectorAll('[data-cjl-assemble]');
    if (headings.length && animate) {
      headings.forEach(function (h) { h.classList.add('is-armed'); });
      var wordIO = new IntersectionObserver(function (entries, io) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-assembled');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });
      headings.forEach(function (h) { wordIO.observe(h); });
      observers.push(wordIO);
    } else {
      headings.forEach(function (h) { h.classList.add('is-assembled'); });
    }

    /* Escenas: reveal de entrada + cesión de salida (S3). Los tops sticky se CACHEAN
       del CSS ya resuelto (getComputedStyle) — nunca se duplica la fórmula del deck —
       y se recachean en resize. El disparo de entrada es por posición (la tarjeta llegó
       a su tope), determinista; el IO de 0.9 queda solo de respaldo (llegadas por ancla).
       La salida escribe estilos inline SOLO en el wrapper [data-body] (sin transition)
       y publica --p en el field (franja del nombre + filo ::after). */
    var rafId = 0, watching = false, onResize = null;
    if (animate) {
      root.classList.add('js-scenes');
      var fieldEls = [].slice.call(root.querySelectorAll('.cjl-familias__field'));
      var bodies = fieldEls.map(function (f) { return f.querySelector('[data-body]'); });
      var live = fieldEls.map(function () { return false; });
      var stickTops = [];

      var cacheTops = function () {
        fieldEls.forEach(function (f, i) {
          stickTops[i] = parseFloat(getComputedStyle(f).top) || 0;
        });
      };
      cacheTops();

      var liveIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-live'); liveIO.unobserve(e.target); }
        });
      }, { threshold: 0.35 }); /* 0.9 nunca se cumplía en móvil: la tarjeta es más alta que la pantalla */
      fieldEls.forEach(function (f) { liveIO.observe(f); });
      observers.push(liveIO);

      var deskMQ = window.matchMedia('(min-width: 990px)');
      /* Indicador 01/04 (plan v4): la tarjeta activa es la última que llegó a su
         tope sticky. Se actualiza solo cuando cambia. */
      var ixN = root.querySelector('[data-ix-n]');
      var ixSegs = root.querySelectorAll('.cjl-familias__ix-segs i');
      var ixCur = 0;
      var setIx = function (n) {
        if (n === ixCur || !ixSegs.length) return;
        ixCur = n;
        if (ixN) ixN.textContent = n < 9 ? '0' + (n + 1) : '' + (n + 1);
        ixSegs.forEach(function (seg, k) { seg.classList.toggle('is-on', k === n); });
      };
      var introInner = root.querySelector('.cjl-familias__intro-inner');
      /* Cierre a la medida de la intro (24 sep, QA medido). Antes el outro medía
         una pantalla entera y el JS arrastraba la intro: en ventanas altas quedaba
         un vacío de crema que crecía con la altura. Ahora el outro mide lo mismo
         que la zona sticky de la intro (top + alto + padding inferior), así el
         módulo termina justo bajo el bloque Sun y el propio sticky lo suelta al
         mismo ritmo que el cierre — sin traslación JS. El centro del mensaje va
         al centro del bloque Sun (--intro-mid). */
      var setIntroMid = function () {
        if (!introInner) return;
        var s0 = parseFloat(getComputedStyle(introInner).top) || 0;
        var pb = parseFloat(getComputedStyle(introInner.parentNode).paddingBottom) || 0;
        var h = introInner.offsetHeight;
        root.style.setProperty('--intro-mid', (s0 + h / 2).toFixed(1) + 'px');
        root.style.setProperty('--outro-h', (s0 + h + pb).toFixed(1) + 'px');
      };
      /* Marca de agua (s19): cada palabra llena el ancho del campo de color (= ancho
         del nombre, col 1 del grid) menos 12px por lado. Se mide a 100px y se escala. */
      var fitWm = function () {
        fieldEls.forEach(function (f) {
          var wm = f.querySelector('.cjl-familias__wm');
          var name = f.querySelector('.cjl-familias__name');
          if (!wm || !name) return;
          wm.style.fontSize = '';
          if (getComputedStyle(wm).display === 'none') return;
          wm.style.fontSize = '100px';
          var r = document.createRange();
          r.selectNodeContents(wm);
          var w = r.getBoundingClientRect().width, target = name.offsetWidth - 24;
          wm.style.fontSize = (w && target > 0) ? (100 * target / w).toFixed(1) + 'px' : '';
        });
      };
      var layout = function () { setIntroMid(); fitWm(); };
      layout();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
      var tick = function () {
        if (!watching) return;
        var vh = window.innerHeight;
        if (deskMQ.matches && ixSegs.length) {
          var act = 0;
          for (var a = 0; a < ixSegs.length && a < fieldEls.length; a++) {
            if (fieldEls[a].getBoundingClientRect().top <= stickTops[a] + 50) act = a;
          }
          setIx(act);
        }
        for (var i = 0; i < fieldEls.length; i++) {
          var top = fieldEls[i].getBoundingClientRect().top;
          /* Arranque (29 sep): al llegar al tope sticky O con ~45 % de la tarjeta en pantalla,
             lo que ocurra antes — así la escena entra mientras la tarjeta sube, no después. */
          if (!live[i] && top <= Math.max(stickTops[i] + 48, vh * 0.55)) {
            fieldEls[i].classList.add('is-live');
            live[i] = true;
          }
          var body = bodies[i];
          if (!body || i === fieldEls.length - 1) continue;
          /* s19: en ordenador el cierre puede estar oculto (botón en la intro): la última
             tarjeta visible no cede ante una que no existe. */
          if (!fieldEls[i + 1].offsetHeight) {
            body.style.opacity = ''; body.style.transform = '';
            fieldEls[i].style.removeProperty('--p');
            continue;
          }
          if (!deskMQ.matches) {
            body.style.opacity = ''; body.style.transform = '';
            fieldEls[i].style.removeProperty('--p');
            continue;
          }
          var nextTop = fieldEls[i + 1].getBoundingClientRect().top;
          var p = (vh - nextTop) / (vh - stickTops[i + 1]);
          p = p < 0 ? 0 : p > 1 ? 1 : p;
          fieldEls[i].style.setProperty('--p', p.toFixed(3));
          body.style.opacity = (1 - p).toFixed(3);
          body.style.transform = p > 0
            ? 'translateY(' + (-24 * p).toFixed(1) + 'px) scale(' + (1 - 0.03 * p).toFixed(4) + ')'
            : '';
        }
        rafId = requestAnimationFrame(tick);
      };
      var nearIO = new IntersectionObserver(function (entries) {
        var near = entries.some(function (e) { return e.isIntersecting; });
        if (near === watching) return;
        watching = near;
        cancelAnimationFrame(rafId);
        if (near) rafId = requestAnimationFrame(tick);
      }, { rootMargin: '30% 0px' });
      nearIO.observe(root);
      observers.push(nearIO);

      var resizeT = 0;
      onResize = function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(function () { cacheTops(); layout(); }, 150);
      };
      window.addEventListener('resize', onResize);
    }

    instances[id] = {
      destroy: function () {
        observers.forEach(function (o) { o.disconnect(); });
        watching = false;
        cancelAnimationFrame(rafId);
        if (onResize) window.removeEventListener('resize', onResize);
        root.querySelectorAll('.cjl-familias__field').forEach(function (f) {
          f.style.removeProperty('--p');
        });
        delete instances[id];
      }
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-cjl-familias]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-cjl-familias]');
    if (root && instances[root.dataset.sectionId]) instances[root.dataset.sectionId].destroy();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
})();
